import _ from "underscore";
import i18n from '../../i18n.js';

export const NetworkTypes = {
  BROADCAST: {
    id: "BROADCAST",
    text: i18n.t('network.networktypes.broadcast')
  },
  NETMASK: {
    id: "NETMASK",
    text: i18n.t('network.networktypes.netmask')
  },
  RANGE: {
    id: "RANGE",
    text: i18n.t('network.networktypes.iprange')
  },
};

export const networkTypeDataSourceConfig = {
  store: {
    type: "array",
    data: _.values(NetworkTypes),
    key: "id"
  },
  map: rec => _.extend({ value: rec.id }, rec)
}

export const formatNetworkTypeText = key =>
  key in NetworkTypes ? NetworkTypes[key].text : key;
